export const RESEND_OTP_TIMEOUT = 120